"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const abstract_block_component_1 = require("../abstract-block/abstract-block.component");
const users_service_1 = require("../../../../../shared/users/users.service");
let BuildingBlockAuthorComponent = 
// eslint-disable-next-line max-len
class BuildingBlockAuthorComponent extends abstract_block_component_1.AbstractBuildingBlock {
    constructor(usersService) {
        super();
        this.userName = 'Muster Verkäufer';
        this.userPosition = 'Verkaufsberater';
        const userId = usersService.currentUserId();
        if (!userId)
            return;
        const user = usersService.getUserFromId(userId);
        if (!user)
            return;
        this.userName = `${user.first_name} ${user.last_name}`;
        this.userPosition = user.position;
    }
};
BuildingBlockAuthorComponent = __decorate([
    (0, core_1.Component)({
        selector: 'block-author',
        templateUrl: require('./block-author.component.html'),
    })
    // eslint-disable-next-line max-len
    ,
    __metadata("design:paramtypes", [typeof (_a = typeof users_service_1.UsersService !== "undefined" && users_service_1.UsersService) === "function" ? _a : Object])
], BuildingBlockAuthorComponent);
exports.default = BuildingBlockAuthorComponent;
